var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("hr", { staticClass: "my-2" }),
      _vm._v(" "),
      _c("insertVoucherForm", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.status === _vm.status_insert,
            expression: "status === status_insert",
          },
        ],
      }),
      _vm._v(" "),
      _c("checkedVoucherResume", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.status === _vm.status_checked,
            expression: "status === status_checked",
          },
        ],
      }),
      _vm._v(" "),
      _c("confirmVoucherRedeemed", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.status === _vm.status_confirmed,
            expression: "status === status_confirmed",
          },
        ],
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }